import $ from 'jquery';
import Slider, {
  cssClassLazyloadOnSlide,
  cssClassSwiperSlide,
} from '../../js/modules/Slider.mjs';
import {
  gridBreakpoints,
  gridGutterWidth,
} from '../../js/utilities/media-queries.mjs';

const $sliders = $('.js_ef-collection-teaser-wave');

$sliders.each((index, slider) => {
  const $slider = $(slider);
  const $sliderWrapper = $slider.find('.ef-collection-teaser-wave__slider-wrapper');
  const $sliderSlides = $slider.find('.ef-collection-teaser-wave__slider-slide');
  const SliderCollectionTeaserWave = new Slider({
    namespace: 'CollectionTeaserWave',
    sliderNode: slider,
    $wrapper: $sliderWrapper,
    swiperConfigOverride: {
      breakpoints: {
        [gridBreakpoints.xs]: {
          slidesPerView: 1,
          spaceBetween: gridGutterWidth
        },
        [gridBreakpoints.md]: {
          slidesPerView: 2,
          spaceBetween: gridGutterWidth
        },
        [gridBreakpoints.lg]: {
          slidesPerView: 3,
          spaceBetween: gridGutterWidth
        }
      }
    },
    callbacks: {
      onInitStart() {
        $sliderWrapper.addClass('no-gutters');
        $sliderSlides.addClass(cssClassSwiperSlide);
      },
      onDestroy() {
        $sliderWrapper.removeClass('no-gutters');
        $sliderSlides.removeClass(cssClassSwiperSlide);
      },
    },
  });

  if (SliderCollectionTeaserWave.slidesDontFitIntoWrapper()) {
    SliderCollectionTeaserWave.init();
  } else {
    $slider.find(`.${cssClassLazyloadOnSlide}`).addClass('lazyload');
  }
  SliderCollectionTeaserWave.attachResize();
});
